/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/Payment";

export function echeck(values) {
  return APIClient.post(`${endpoint}/Echeck`, values);
}
export function getPaymentType() {
  return APIClient.get(`${endpoint}/type`);
}
export function getCardType(body) {
  return APIClient.post(`${endpoint}/cardtype` , body);
}
export function creadit(values) {
  return APIClient.post(`${endpoint}/creaditCard`, values);
}

export function customPayment(values) {
  return APIClient.post(`${endpoint}/custom/`, values);
}

export function additionalPayment(values) {
  return APIClient.post(`/Order/Special/add`, values);
}

// export function checkCartType(values) {
//   return APIClient.post(`${endpoint}/cartType`, values);
// }
